import { cva } from "class-variance-authority"

const buttonVariants = cva(
  "inline-flex items-center justify-center px-4 py-2 gap-2 border border-transparent whitespace-nowrap rounded text-sm font-bold transition-all duration-300 disabled:pointer-events-none disabled:bg-grey disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive cursor-pointer",
  {
    variants: {
      variant: {
        primary:
          "bg-primary-green text-primary-text-on-bg shadow-xs hover:bg-primary-dark-green",
        secondary:
          "border border-primary-accent-blue bg-transparent text-primary-dark-blue hover:bg-primary-green hover:border-primary-green hover:text-primary-text-on-bg",
        outline: "bg-transparent border border-primary-dark-blue",
        underline: "bg-transparent border-none underline px-0 py-0 font-normal",
        unstyled: "bg-transparent border-none !p-0",
        input:
          "bg-transparent disabled:text-black/70 disabled:!opacity-80 disabled:!cursor-not-allowed",
        darkBlue:
          "border bg-primary-dark-blue text-white hover:bg-transparent hover:border-primary-dark-blue hover:text-primary-dark-blue",
        ghost:
          "bg-transparent border border-primary-accent-blue disabled:text-grey disabled:!bg-transparent disabled:cursor-not-allowed",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  },
)

export default buttonVariants
